import gql from 'graphql-tag';

export const collaboratingUserRoleChangedOnSurfaceSubscription = gql`
  subscription collaboratingUserRoleChangedOnSurface(
    $surface: ID!
    $user: ID!
  ) {
    collaboratingUserRoleChangedOnSurface(surface: $surface, user: $user) {
      surface
      role
      user
    }
  }
`;
